import { gql } from '@apollo/client';
const SPECIFICATION = gql `
  fragment SpecificationFragment on ModelSpecificationNode {
    id
    modifiedDate
    createdDate
    archivedAt
    itemCode
    state
    fancyName
    category {
      id
      name
      image
    }
    folder {
      id
      name
      modelSpecificationsCount
    }
    season {
      name
    }
    status {
      id
      namePL
      nameEN
      color
    }
    image
    projections {
      edges {
        node {
          id
          picture
        }
      }
    }
    componentsCount
    sizes {
      edges {
        node {
          id
          isActive
          sizeName {
            id
            name
          }
        }
      }
    }
    components {
      edges {
        node {
          id
          name
          photo
          productCategory {
            id
            type
            typeLabelPL
            typeLabelEN
            typeIcon
          }
          productSnapshot {
            id
            name
            productDescription
            supplierFullName
            supplierShortName
            width
            componentSize
            composition
            zipperType
            grammage
            producerCode
            underSliderType
            upperSliderType
            yardage
            image
            product {
              id
              name
              status
              pictures {
                edges {
                  node {
                    id
                    image
                  }
                }
              }
              zipperType {
                id
                name
                upperSlider
                underSlider
              }
              grammage {
                id
                name
              }
              componentSize {
                id
                name
              }
              width {
                id
                name
              }
              composition {
                id
                name
              }
              producerCode {
                id
                name
              }
              underSliderType {
                id
                name
              }
              upperSliderType {
                id
                name
              }
              yardage {
                id
                name
              }
            }
          }
        }
      }
    }
    brand {
      name
    }
    assignedOrderId
  }
`;
export default SPECIFICATION;
